import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

interface TimesheetPeriodNavigationProps {
  periodStart: string; // YYYY-MM-DD
  periodEnd: string;   // YYYY-MM-DD
  payPeriodType: string; // 'biweekly' or 'monthly'
  onNavigate: (date: string) => void; // called with a date within the desired period
}

const formatPeriodDisplay = (start: string, end: string): string => {
  const startDate = new Date(start + 'T00:00:00');
  const endDate = new Date(end + 'T00:00:00');

  const startDow = startDate.toLocaleDateString('en-US', { weekday: 'short' });
  const startMonth = startDate.toLocaleDateString('en-US', { month: 'short' });
  const endDow = endDate.toLocaleDateString('en-US', { weekday: 'short' });
  const endMonth = endDate.toLocaleDateString('en-US', { month: 'short' });
  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const year = endDate.getFullYear();

  return `${startDow} ${startMonth} ${startDay} - ${endDow} ${endMonth} ${endDay}, ${year}`;
};

const TimesheetPeriodNavigation: React.FC<TimesheetPeriodNavigationProps> = ({
  periodStart,
  periodEnd,
  payPeriodType,
  onNavigate,
}) => {
  const handlePrevious = () => {
    const start = new Date(periodStart + 'T00:00:00');
    if (payPeriodType === 'monthly') {
      start.setMonth(start.getMonth() - 1);
    } else {
      start.setDate(start.getDate() - 1); // Go to day before period start
    }
    onNavigate(start.toISOString().split('T')[0]);
  };

  const handleNext = () => {
    const end = new Date(periodEnd + 'T00:00:00');
    end.setDate(end.getDate() + 1); // Go to day after period end
    onNavigate(end.toISOString().split('T')[0]);
  };

  const handleToday = () => {
    onNavigate(new Date().toLocaleDateString('en-CA'));
  };

  return (
    <div className="d-flex align-items-center gap-3">
      <ButtonGroup size="sm">
        <Button variant="outline-secondary" onClick={handlePrevious}>
          <i className="bi bi-chevron-left"></i>
        </Button>
        <Button variant="outline-secondary" onClick={handleNext}>
          <i className="bi bi-chevron-right"></i>
        </Button>
      </ButtonGroup>
      <span className="fw-semibold">
        {formatPeriodDisplay(periodStart, periodEnd)}
      </span>
      <Button variant="outline-primary" size="sm" onClick={handleToday}>
        Today
      </Button>
    </div>
  );
};

export default TimesheetPeriodNavigation;
